import { io } from 'socket.io-client'

import env from './environments'

const URL = env.apiUrl

export const socket = io(URL, { withCredentials: true, transports: ['websocket'] })
